import { prop } from 'ramda';
import { useMemo } from 'react';
import { useComponentConfig } from 'js/hooks/component';
import { htcmdService } from 'js/services/htcmd.service';
import { useDeviceSelector } from 'js/store/hooks';

export const useKambiCustomerSettings = () => {
    const formFactor = useDeviceSelector(prop('formFactor'));
    const {
        mobileCustomerSettings,
        tabletCustomerSettings,
        desktopCustomerSettings,
        nativeCustomerSettings
    } = useComponentConfig();

    return useMemo(() => {
        try {
            if (htcmdService.isEnabled) {
                return JSON.parse(nativeCustomerSettings);
            }

            switch (formFactor) {
                case 'desktop':
                    return JSON.parse(desktopCustomerSettings);

                case 'tablet':
                    return JSON.parse(tabletCustomerSettings);

                case 'mobile':
                    return JSON.parse(mobileCustomerSettings);

                default:
                    return {};
            }
        } catch (e) {
            return {};
        }
    }, [
        formFactor,
        desktopCustomerSettings,
        tabletCustomerSettings,
        mobileCustomerSettings,
        nativeCustomerSettings
    ]);
};
